
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-orders",
      function () {
        return require("private-next-pages/my-orders/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-orders"])
      });
    }
  